<template>
	<div>
		<footer class="footer">
			<div class="container-fluid">
				<div class="row">
					<div class="col-sm-6">
						{{new Date().getFullYear()}} {{$t('projectName')}}.
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>
<script>
export default {
	data() {
		return {
			
		};
	},
};
</script>